// extracted by mini-css-extract-plugin
export var card = "styles-module--card--2AAxU";